import {axiosInstance} from "@/plugins/axios";
import {MaterialDeclarationTransactionFilter} from "@/modules/material_declaration_transaction/types"

export async function getMaterialDeclarationTransactions(payload: MaterialDeclarationTransactionFilter) {
  let url = 'material_declaration_transactions?';

  if (payload && payload.start_application_date !== "" && payload.end_application_date !== "") {
    url += `start_application_date=${payload.start_application_date}&end_application_date=${payload.end_application_date}&`
  }

  if (payload && payload.id_supplier) {
    url += `id_supplier=${payload.id_supplier}&`
  }

  if (payload.limit) {
    url += `limit=${payload.limit}&offset=${payload.offset}`;
  }

  if (payload.id_agreement_group) {
    url += `&id_agreement_group=${payload.id_agreement_group}`;
  }
  const response = await axiosInstance.get(url);
  return response.data;
}
